import { CheckoutState } from '../../state';
import {
    isEventbriteTLDInDevOrQAEnv,
    isIosWebView,
    isSafari,
    isSocialWebView,
} from '../../utils/browser';
import { isEventbriteTLD } from '../app';
import { isGooglePayAvailableAsExpressPaymentMethod } from '../expressCheckout';
import { isGooglePayAvailableAsPaymentMethod } from '../order';
import { getIsPaymentView, isTicketSelectionFullSizePage } from '../routing';
import { getCanMakePaymentsWithGooglePay } from './pureSelectors';

export const isGooglePayAvailable = (state: CheckoutState) => {
    return (
        getCanMakePaymentsWithGooglePay(state) &&
        (isEventbriteTLD(state) || isEventbriteTLDInDevOrQAEnv()) &&
        !isIosWebView() &&
        !isSocialWebView() &&
        !isSafari()
    );
};

export const isGooglePayAvailableInPage = (state: CheckoutState) =>
    (isTicketSelectionFullSizePage(state) &&
        isGooglePayAvailableAsExpressPaymentMethod(state)) ||
    (getIsPaymentView(state) && isGooglePayAvailableAsPaymentMethod(state));
